/* ClinicianPage auto-generated by npm run generator */
import { CircularProgress, makeStyles, Theme, Typography } from "@material-ui/core"
import { PortalRole } from "@qlarity/common"
import ClinicianCharts from "components/molecules/charts/ClinicianCharts"
import ClinicianPageTable from "components/molecules/ClinicianPageTable"
import ClinicianMenu from "components/molecules/dropdowns/ClinicianMenu"
import { useCollectionSubscribe, useDocSubscribe } from "hooks/useSnapshots"
import { observer } from "mobx-react"
import React from "react"
import { useParams } from "react-router-dom"
import Store from "store/Store"
import { CsvButton } from "components/molecules/CsvButton"

interface ClinicianPageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    clinicianPagePage: {
        display: "grid",
        gridGap: theme.spacing(8),
    },
    header: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: theme.spacing(2),
        gridAutoColumns: "max-content",
        alignItems: "center",
    },
}))

const ClinicianPage: React.FC<ClinicianPageProps> = (props) => {
    const classes = useStyles()
    const { clinicianId, orgId } = useParams()
    const clinician = useDocSubscribe(Store.auth.clinicianCollection.doc(clinicianId))
    const clients = useCollectionSubscribe(Store.auth.clientCollection.where("clinicianId", "==", clinicianId).where("orgId", "==", orgId))

    if (!clinicianId) {
        return <div>Clinicician not found</div>
    }

    if (!clinician) {
        return <CircularProgress />
    }

    return (
        <div className={classes.clinicianPagePage}>
            <div className={classes.header}>
                <Typography variant="h5">{clinician.displayName}</Typography>
                <CsvButton clients={clients} />

                {(Store.auth.portalUser?.role === PortalRole.ADMIN || Store.auth.portalUser?.role === PortalRole.ORG_ADMIN) && (
                    <ClinicianMenu clinician={clinician} />
                )}
            </div>

            <ClinicianCharts clinician={clinician} clients={clients} />

            <ClinicianPageTable clinician={clinician} clients={clients} />
        </div>
    )
}

export default observer(ClinicianPage)
